import { connect } from 'react-redux';
import { getDRE } from '../publicSession/selectors';
var mapStateToProps = function (state) { return ({
    dre: getDRE(state),
}); };
export default connect(mapStateToProps);
//# sourceMappingURL=dre.container.js.map